import React, { useEffect, useState } from 'react';
import { useDeepCompareEffect, useEffectOnce } from 'react-use';
import { Typography, Accordion, AccordionDetails, AccordionSummary, withStyles, } from "@material-ui/core";
import ReactLoading from 'react-loading';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { usePedidos } from '../../../../contexts/Pedidos';
import { useHistory } from 'react-router-dom';
import { ArrayCondicaoPagamento, ArrayFormaPagamento, CondicaoPagamento, FormaPagamento, InfoCabecalhoResumo, ItemResumoPrePedido, ResumoPrePedido, Transportadora } from '../../interfaces';
import { FieldText } from '../../../../themes/components/FieldText';
import { FieldDropdown, FieldDropdownVer2 } from '../../../../themes/components/FieldDropdown';
import { TabelaListaItensResumoPedido } from '../TabelaListaItensResumoPedido';
import { compareDatas, compareDatasAntigas, mascaraDataDDMMAAAA } from '../../../../util/fieldMasks';
import { FaRegSave } from 'react-icons/fa';
import { FiEdit } from 'react-icons/fi';
import { useModals } from '../../../../contexts/Modals';
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/pt-br';
import moment from 'moment';
import $ from 'jquery';
import { Button } from '../../../../themes/components/Button';
import TextField from '@mui/material/TextField';

interface propsItemResumoPedido {
    pedido: ResumoPrePedido;
    numPed: number;
    loadingProgress: boolean;
    setResumosEmEdicao: React.Dispatch<React.SetStateAction<number>>;
    resumosEmEdicao: number;
    prevFatOrigin: string | undefined;
    resumosPedidos: ResumoPrePedido[];
    setResumosPedidos: React.Dispatch<React.SetStateAction<ResumoPrePedido[] | undefined>>;
}

export function ItemResumoPedido(props: propsItemResumoPedido) {
    const { buscarCondPGTO, buscarFormaPGTO, novoPedido, tiposFrete, buscarTransportadora, updateResumoPrePedido } = usePedidos();
    const { setMensagem, setShowModalProgress, showModalProgress, mostrarInfoOK, setShowModalInfo } = useModals();
    const history = useHistory();
    let dataItem = new Date(props.pedido.data_entrega.replace(new RegExp("T|\\.000\\+00\\:00", "g"), " ").trim());
    let dataMinFat = new Date(props.pedido.numero_container !== "999" ? props.pedido.previsao_container.replace(new RegExp("T|\\.000\\+00\\:00", "g"), " ").trim() : props.pedido.data_entrega.replace(new RegExp("T|\\.000\\+00\\:00", "g"), " ").trim());
    let dataItemFormat = "";
    //Data formatada com time UTC, igual ao do banco de dados
    dataItemFormat = String((dataItem.getDate() < 10 ? '0' : '') + dataItem.getDate() + "/" + ((dataItem.getMonth() < 9 ? '0' : '') + String(dataItem.getMonth() + 1)) + "/" + dataItem.getFullYear()) || ""
    //dataMinFat = new Date((dataMinFat.getUTCDate() < 10 ? '0' : '') + dataMinFat.getUTCDate() + "/" + ((dataMinFat.getUTCMonth() < 9 ? '0' : '') + String(dataMinFat.getUTCMonth() + 1)) + "/" + dataMinFat.getUTCFullYear()) || ""
    const [fieldObsItem, setFieldObsItem] = useState("");
    const [fieldDataEnt, setFieldDataEnt] = useState(dataItemFormat);
    const [fieldFrete, setFieldFrete] = useState<string>();
    const [listaCondPGTO, setListaCondPGTO] = useState<ArrayCondicaoPagamento>();
    const [listaFormaPGTO, setListaFormaPGTO] = useState<ArrayFormaPagamento>();
    const [fieldCondPagamento, setFieldCondPagamento] = useState<CondicaoPagamento>();
    const [fieldFormaPagamento, setFieldFormaPagamento] = useState<FormaPagamento>();
    const [loadingTransp2, setLoadingTransp2] = useState<boolean>(false);
    const [listaTransp2, setListaTransp2] = useState<Transportadora[]>([]);
    const [fieldTranportadora2, setFieldTranportadora2] = useState<Transportadora>();
    const [loadingCondicaoPGTO, setLoadingCondicaoPGTO] = useState<boolean>(false);
    const [loadingFormaPGTO, setLoadingFormaPGTO] = useState<boolean>(false);
    const [loadingInfoTransp2, setLoadingInfoTransp2] = useState<boolean>(true);
    const [loadingInfoCond, setLoadingInfoCond] = useState<boolean>(true);
    const [loadingInfoForma, setLoadingInfoForma] = useState<boolean>(true);
    const [showSaveButton, setShowSaveButton] = useState<boolean>(false);
    const [alertou, setAlertou] = useState<boolean>(false);
    const options = {
        timeZone: 'Africa/Bissau', // Lista de Timezones no fim do artigo
        hour12: false, // Alterna entre a mostragem dos horários em 24 horas, ou então AM/PM
    }

    const TextFieldObs = withStyles({
        root: {
            '& legend': {
                display: 'none',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'yellow',
            },
            '& .MuiOutlinedInput-root': {
                '& input': {
                    zIndex: '999'
                },
                '& fieldset': {
                    color: 'black',
                    borderColor: '#ccc',
                    paddingTop: '5px',
                    backgroundColor: 'white',
                },
                '&:hover fieldset': {
                    borderColor: '#ccc',
                },
                '&.Mui-focused fieldset': {
                    borderColor: '#ccc',
                    borderWidth: '1px',
                    color: 'black',
                },
            },
        },
    })(TextField);

    function getCodTipoFrete(nome: string) {
        tiposFrete.forEach(element => {
            if (element.desc === nome) {
                return element.cod;
            }
        });
        return "";
    }

    function handleChangeCondicaoPGTO(event: any, option: string, reason: any) {
        let cod = "";
        let desc = "";

        if (event !== null && event.target.value !== "" && reason === "input") {
            if (new RegExp("[0-9]+", 'g').test(event.target.value)) {
                cod = event.target.value as string;
            } else {
                desc = event.target.value as string;
            }
            setLoadingCondicaoPGTO(true);
            getCondicao(cod, desc);
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]*").exec(option)
            let tempPedido = novoPedido
            tempPedido.condpag = parseInt(cod ? cod[0] : "");
            if (cod !== null) {
                if (listaCondPGTO !== undefined) {
                    for (let index = 0; index < listaCondPGTO.length; index++) {
                        const element = listaCondPGTO[index];
                        if (cod !== null && element.codcpg === cod[0]) {
                            setFieldCondPagamento(element);
                            break;
                        }
                    }
                }
                //setNovoPedido(tempPedido);
            }
        }
    };


    function handleChangeFormaPGTO(event: any, option: string, reason: any) {
        let cod = "";
        let desc = "";

        if (reason === "input" && event !== null && event.target.value !== "") {
            if (new RegExp("[0-9]+", 'g').test(event.target.value)) {
                cod = event.target.value as string;
            } else {
                desc = event.target.value as string;
            }
            console.log(event.target.value);
            setLoadingFormaPGTO(true);
            getForma(cod, desc);
        }
        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]*").exec(option)
            let tempPedido = novoPedido
            tempPedido.formapag = cod ? cod[0] : ""
            if (cod !== null) {
                if (listaFormaPGTO !== undefined) {
                    for (let index = 0; index < listaFormaPGTO.length; index++) {
                        const element = listaFormaPGTO[index];
                        if (cod !== null && element.codfpg === cod[0]) {
                            setFieldFormaPagamento(element);
                            break;
                        }
                    }
                }
                //setNovoPedido(tempPedido);
            }
        }
    };

    function handleFrete(event: any, option: string, reason: any) {
        if (reason === "reset" && option.trim() !== "") {
            setFieldFrete(option);
        }
    }

    function handleChangeTransp2(event: any, option: string, reason: any) {
        if (reason === "input" && event !== null && event.target.value.trim() !== "") {
            setFieldTranportadora2(undefined);
            setLoadingTransp2(true);
            getTransportadora2(event.target.value);
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]*", '').exec(option);
            let nomeproduto = option.replace(new RegExp("(.*- )", ''), "");
            if (cod !== null) {
                setFieldTranportadora2({ "codtra": cod[0], "nomtra": nomeproduto });
            } else {
                setFieldTranportadora2(undefined);
            }
        }

        if (reason === "clear" || (event !== null && String(event.target.value).trim() === "")) {
            setFieldTranportadora2(undefined);
        }
    }

    async function getTransportadora2(value: string) {
        await buscarTransportadora(value, history)
            .then((res) => {
                setListaTransp2(res);
                setLoadingTransp2(false);
            })
            .catch((err) => {
                if (err !== "Cancel") {
                    setListaTransp2([]);
                    console.log(err);
                    setLoadingTransp2(false);
                }
            })
    }

    function atualizarItemInfo() {
        async function update(resumo: string) {
            await updateResumoPrePedido(resumo, props.pedido.id, history)
                .then((res:ResumoPrePedido) => {
                    let tempResumosPedidos: ResumoPrePedido[] = props.resumosPedidos;
                    for(let i=0;i<tempResumosPedidos.length;i++){
                        let element = tempResumosPedidos[i];
                        if(element.id === res.id){
                            tempResumosPedidos[i].observacao = res.observacao;
                        }
                    }
                    props.setResumosPedidos(tempResumosPedidos);
                    setShowSaveButton(false);
                    setShowModalProgress(false);
                    props.setResumosEmEdicao(props.resumosEmEdicao - 1);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        console.log(err);
                        setShowModalProgress(false);
                    }
                })
        }

        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>Atualizando resumo do Pedido</Typography>
                <ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} />
            </div>
        );
        setShowModalProgress(true);
        let newResume: InfoCabecalhoResumo = {};
        if (fieldCondPagamento?.codcpg !== undefined) {
            newResume.condpag = parseInt(fieldCondPagamento.codcpg);
            newResume.nomecondpag = fieldCondPagamento.descpg;
        }
        if (fieldFormaPagamento?.codfpg !== undefined) {
            newResume.formapag = fieldFormaPagamento.codfpg;
            newResume.nomeformapag = fieldFormaPagamento.desfpg;
        }
        if (fieldObsItem !== undefined) newResume.observacao = fieldObsItem;
        if (fieldFrete !== undefined) newResume.tipofrete = getCodTipoFrete(fieldFrete);
        if (fieldTranportadora2?.codtra !== undefined) newResume.transportadora2 = fieldTranportadora2.codtra;
        if (fieldDataEnt !== undefined) newResume.dataentrega = fieldDataEnt;
        update(JSON.stringify(newResume))
    }

    function buscaFrete(option: string) {
        for (let index = 0; index < tiposFrete.length; index++) {
            const element = tiposFrete[index];
            if (element.cod === option) {
                return element.desc
            }
        }
        return "";
    }

    async function getForma(cod: string, desc: string) {
        await buscarFormaPGTO(cod, desc, history)
            .then((res) => {
                setListaFormaPGTO(res);
                setLoadingFormaPGTO(false);
            })
            .catch((err) => {
                if (err !== "Cancel") {
                    setListaFormaPGTO([]);
                    setLoadingFormaPGTO(false);
                }
            })
    }

    async function getCondicao(cod: string, desc: string) {
        await buscarCondPGTO(cod, desc, history)
            .then((res) => {
                setListaCondPGTO(res);
                setLoadingCondicaoPGTO(false);
            })
            .catch((err) => {
                if (err !== "Cancel") {
                    setListaCondPGTO([]);
                    setLoadingCondicaoPGTO(false);
                }
            })
    }

    //Esse efeito é responsável por carregar os valores padrões vindo do resumo da base
    useEffectOnce(() => {
        async function getTransp2(value: string) {
            await buscarTransportadora(value, history)
                .then((res) => {
                    setListaTransp2(res);
                    for (let index = 0; index < res.length; index++) {
                        const element = res[index];
                        if (element.codtra === String(props.pedido.cod_transportadora2)) {
                            setFieldTranportadora2({ "codtra": element?.codtra, "nomtra": element?.nomtra });
                        }
                    }
                    setLoadingInfoTransp2(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaTransp2([]);
                        console.log(err);
                        setLoadingInfoTransp2(false);
                    }
                })

        }
        async function getFormaPGTO(cod: string, desc: string) {
            await buscarFormaPGTO(cod, desc, history)
                .then((res) => {
                    setListaFormaPGTO(res);
                    for (let index = 0; index < res.length; index++) {
                        const element = res[index];
                        if (element.codfpg === cod) {
                            setFieldFormaPagamento(element);
                            setLoadingInfoForma(false);
                        }
                    }
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaFormaPGTO([]);
                        setLoadingInfoForma(false);
                    }
                })
        }

        async function getCondicaoPGTO(cod: string, desc: string) {
            await buscarCondPGTO(cod, desc, history)
                .then((res) => {
                    setListaCondPGTO(res);
                    for (let index = 0; index < res.length; index++) {
                        const element = res[index];
                        if (element.codcpg === cod) {
                            setFieldCondPagamento(element);
                            setLoadingInfoCond(false);
                        }
                    }
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaCondPGTO([]);
                        setLoadingCondicaoPGTO(false);
                        setLoadingInfoCond(false);
                    }
                })
        }
        //Atualizando campos
        setFieldFrete(buscaFrete(props.pedido.tipo_frete));
        getTransp2(String(props.pedido.cod_transportadora2));
        getFormaPGTO(props.pedido.cod_forma_pag, "");
        getCondicaoPGTO(String(props.pedido.cod_condicao_pag), "");
    });

    function atualizaCampoData(value: string) {
        let campo = (document.getElementById(`campoDataItem${props.pedido.id}`) as HTMLInputElement)?.getElementsByTagName("input").item(0);
        if (campo !== null) campo.value = value;
    }

    function handleDate(jsDate: Date, dateString: string) {
        let campo = (document.getElementById(`campoDataItem${props.pedido.id}`) as HTMLInputElement)?.getElementsByTagName("input").item(0)
        if (dateString !== "Data inválida") {
            if (props.pedido.numero_container === "999") {
                if (compareDatas(jsDate, moment().toDate())) {
                    let dataFormatada = (jsDate.getDate() < 10 ? '0' : '') + jsDate.getDate() + "/" + ((jsDate.getMonth() < 9 ? '0' : '') + String(jsDate.getMonth() + 1)) + "/" + jsDate.getFullYear();
                    setFieldDataEnt(dataFormatada);
                } else {
                    setFieldDataEnt(dataItemFormat);
                    setMensagem(
                        <div className='mensagem-info-modal-loading'>
                            <Typography>A data informada não pode ser menor que a data atual.</Typography>
                            <Button onClick={() => [setShowModalInfo(false), atualizaCampoData(dataItemFormat)]} classBtn={"btn-notifications color-default"}>OK</Button>
                        </div>
                    )
                    setShowModalInfo(true);
                }
            } else {
                if (compareDatasAntigas(jsDate, dataMinFat)) {
                    let dataFormatada = (jsDate.getDate() < 10 ? '0' : '') + jsDate.getDate() + "/" + ((jsDate.getMonth() < 9 ? '0' : '') + String(jsDate.getMonth() + 1)) + "/" + jsDate.getFullYear();
                    setFieldDataEnt(dataFormatada);
                } else {
                    setFieldDataEnt(dataItemFormat);
                    setMensagem(
                        <div className='mensagem-info-modal-loading'>
                            <Typography>A data informada não pode ser menor que a data de chegada do container.</Typography>
                            <Typography>{"Previsão de chegada: " + moment(dataMinFat, "DD/MM/YYYY").toDate()}</Typography>
                            <Button onClick={() => [setShowModalInfo(false), atualizaCampoData(dataItemFormat)]} classBtn={"btn-notifications color-default"}>OK</Button>
                        </div>
                    )
                    setShowModalInfo(true);
                }
            }

        } else {
            let textoCampo: string = ""
            $(function () {
                if (campo !== null) {
                    textoCampo = campo.value;
                }
                if (textoCampo !== "") {
                    let data = mascaraDataDDMMAAAA(textoCampo);
                    $(function () {
                        if (campo !== null) {
                            campo.value = data;
                        }
                    })
                    if (data.length !== 10) {
                        //setFieldDataEnt(undefined);
                    }
                } else {
                    //setFieldDataEnt(undefined);
                }
            })
        }
    }

    useEffect(() => {
        if (alertou === false && loadingInfoTransp2 === false && loadingInfoCond === false && loadingInfoForma === false) {
            if (props.pedido.numero_container !== "999" && props.prevFatOrigin !== undefined && compareDatasAntigas(dataMinFat, moment(props.prevFatOrigin, "DD/MM/YYYY").toDate())) {
                setAlertou(true);
                setMensagem(
                    <div className='mensagem-info-modal-loading'>
                        <Typography>A data de faturamento não pode ser menor que a data de chegada do container.</Typography>
                        <Typography>Verifique a nova Previsão de Faturamento dos pedidos container</Typography>
                        <Button onClick={() => [setShowModalInfo(false), atualizaCampoData(dataItemFormat)]} classBtn={"btn-notifications color-default"}>OK</Button>
                    </div>
                )
                setShowModalInfo(true);
            }
        }
    }, [loadingInfoTransp2, loadingInfoCond, loadingInfoForma, alertou])

    //Quando a data é alterada o valor da data é inserido noc ampo atrvés dessa função
    //POis o objeto do tipo picker date não permite a inserção da data como default no campo
    useDeepCompareEffect(() => {
        if (loadingInfoTransp2 === false && loadingInfoCond === false && loadingInfoForma === false) {
            //Atualizando data do campo de texto no formulário de entrega
            if (fieldDataEnt !== undefined) {
                $(function () {
                    let campo = (document.getElementById(`campoDataItem${props.pedido.id}`) as HTMLInputElement)?.getElementsByTagName("input").item(0)
                    if (campo !== undefined && campo !== null) {
                        campo.value = fieldDataEnt;
                    }
                })
            }
        }
    }, [loadingInfoTransp2, loadingInfoCond, loadingInfoForma, fieldDataEnt, showModalProgress])

    function habilitarEdicaoItem() {
        if (showSaveButton === false) {
            setShowSaveButton(true);
            props.setResumosEmEdicao(props.resumosEmEdicao + 1);
        }
        $(function () {
            let campo = (document.getElementById(`campoObsItem${props.pedido.id}`) as HTMLInputElement)?.getElementsByTagName("input").item(0)
            if (campo !== undefined && campo !== null) {
                campo.focus();
            }
            if (showSaveButton === false) mostrarInfoOK("Após editar, salve as informações para continuar");
        })
    }

    function salvarEdicaoItem() {
        atualizarItemInfo();
        props.setResumosEmEdicao(props.resumosEmEdicao - 1);
    }

    function salvarObservacao(event:any){
        const raspado = event.target.value.substring(0, 500);
        setFieldObsItem(raspado)
    }

    return (
        <>
            {props.loadingProgress === false &&
                <div className="resumo-detalhe">
                    <div className="area-title-item-pedido-erp">
                        <div style={{ width: '25px' }}></div>
                        <Typography className="resumo-detalhe-form-title">Informações do Pedido {props.numPed}</Typography>
                        {showSaveButton ?
                            <div>
                                <Button titleText="Salvar" classBtn="btns-edit-save-item-resumo" onClick={() => salvarEdicaoItem()} >
                                    <FaRegSave size={22} style={{ backgroundColor: 'white', color: '#222', marginBottom: '0.5em' }} />
                                </Button>
                            </div>
                            :
                            <div>
                                <Button titleText="Editar Informações" classBtn="btns-edit-save-item-resumo" onClick={() => habilitarEdicaoItem()} >
                                    <FiEdit size={22} style={{ backgroundColor: 'white', color: '#222', marginBottom: '0.5em' }} />
                                </Button>
                            </div>
                        }
                    </div>
                    {loadingInfoTransp2 === false && loadingInfoCond === false && loadingInfoForma === false ?
                        <>
                            <div className="resumo-detalhe-form-row">
                                <div className="resumo-detalhe-form-column">
                                    {field("Tipo do Pedido:", props.pedido.tipo_pedido)}
                                    {field("Empresa:", (props.pedido.cod_empresa == 2 ? "GA" : props.pedido.cod_empresa == 4 ? "AB" : (props.pedido.cod_empresa).toString()))}
                                    {field("Container:", props.pedido.numero_container)}
                                    {field("Corte:", props.pedido.pedido_corte)}
                                    {field("Quantidade de Itens:", String(props.pedido.quantidade_itens))}
                                    {field("Quantidade Total:", props.pedido.quantidade_total.toLocaleString('pt-br', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 }))}
                                    {field("Valor Total:", props.pedido.valor_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))}
                                </div>
                                <div className="resumo-detalhe-form-column">

                                    <div className="cabecalho-detalhe-item">
                                        <Typography className="cabecalho-detalhe-label">Previsão Faturamento: </Typography>
                                    </div>
                                    <div id={`campoDataItem${props.pedido.id}`}>
                                        <DatePickerInput
                                            onChange={handleDate}
                                            locale='pt-br'
                                            displayFormat='DD/MM/YYYY'
                                            className='data-form-entrega'
                                            minDate={moment().toDate()}
                                            disabled={!showSaveButton}
                                        />
                                    </div>
                                    <div className="cabecalho-detalhe-item">
                                        <Typography className="cabecalho-detalhe-label">Frete: </Typography>
                                    </div>
                                    <FieldDropdown
                                        value={fieldFrete}
                                        id="novopedido-combobox-tipo-frete-resumo"
                                        options={tiposFrete.map(opt => opt.desc)}
                                        label={(option: string) => option}
                                        onChange={(event, option, reason) => {
                                            handleFrete(event, option, reason);
                                        }}
                                        disabled={!showSaveButton}
                                    />

                                </div>
                                <div className="resumo-detalhe-form-column">
                                    <div className="cabecalho-detalhe-item">
                                        <Typography className="cabecalho-detalhe-label">Condição de Pagamento: </Typography>
                                    </div>
                                    <FieldDropdownVer2
                                        value={fieldCondPagamento}
                                        id="np-combobox-condicao-pgto-resumo"
                                        options={listaCondPGTO || []}
                                        loading={loadingCondicaoPGTO}
                                        select={(option: CondicaoPagamento, value: CondicaoPagamento) => option.codcpg === value.codcpg}
                                        label={(option: CondicaoPagamento) => option.codcpg !== undefined ? option.codcpg + "-" + option.descpg : ""}
                                        onChange={(event, option, reason) => handleChangeCondicaoPGTO(event, option, reason)}
                                        noOptionsText={"Digite um código ou descrição válido"}
                                        disabled={!showSaveButton}
                                    />

                                    <div className="cabecalho-detalhe-item">
                                        <Typography className="cabecalho-detalhe-label">Forma de Pagamento: </Typography>
                                    </div>
                                    <FieldDropdownVer2
                                        value={fieldFormaPagamento}
                                        id="np-combobox-condicao-forma-resumo"
                                        options={listaFormaPGTO || []}
                                        loading={loadingFormaPGTO}
                                        select={(option: FormaPagamento, value: FormaPagamento) => option.codfpg === value.codfpg}
                                        label={(option: FormaPagamento) => option.codfpg !== undefined ? option.codfpg + "-" + option.desfpg : ""}
                                        onChange={(event, option, reason) => handleChangeFormaPGTO(event, option, reason)}
                                        noOptionsText={"Digite um código ou descrição válido"}
                                        disabled={!showSaveButton}
                                    />

                                </div>
                                {fieldFrete === "(CIF) Por conta do emitente" ?
                                    <div className="resumo-detalhe-form-column">
                                        <div className="cabecalho-detalhe-item">
                                            <Typography className="cabecalho-detalhe-label">Redespacho: </Typography>
                                        </div>
                                        <FieldDropdownVer2
                                            id="additens-combobox-searchtransp2-resumo"
                                            value={fieldTranportadora2}
                                            options={listaTransp2 || []}
                                            loading={loadingTransp2}
                                            select={(option: Transportadora, value: Transportadora) => option.codtra === value.codtra}
                                            label={(option: Transportadora) => option.codtra !== undefined ? option.codtra + " - " + option.nomtra : ""}
                                            onChange={(event, option, reason) => handleChangeTransp2(event, option, reason)}
                                            noOptionsText={"Digite um código ou nome válido"}
                                            disabled={!showSaveButton}
                                        />
                                    </div>
                                    :
                                    <div className="resumo-detalhe-form-column">
                                    </div>
                                }
                            </div>
                            <div className="resumo-detalhe-form-row">
                                <div className="resumo-detalhe-observacao" id={`campoObsItem${props.pedido.id}`}>
                                    <div className="cabecalho-detalhe-item">
                                        <Typography className="cabecalho-detalhe-label">Observação: </Typography>
                                    </div>
                                    {!showSaveButton ?
                                        <TextFieldObs value={fieldObsItem} onClick={() => habilitarEdicaoItem()} />
                                        :
                                        <FieldText
                                            onChange={(event) => salvarObservacao(event)}
                                            value={fieldObsItem}
                                            disabled={!showSaveButton}
                                        />
                                    }
                                </div>
                            </div>
                            <div className="resumo-detalhe-form-row">
                                <Accordion className={props.pedido.cod_empresa == 2?"tabela-itens-resumo-pedido":"tabela-itens-resumo-pedido-1"}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={"resumo-detalhe-form-title show-itens-resumo"}>Itens do Pedido</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <TabelaListaItensResumoPedido allowSelectitem={false} listaItens={props.pedido.produtosResumo} />
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </>
                        :
                        <ReactLoading type={"bars"} color={"#0252a8"} height={25} width={35} />
                    }

                </div>
            }
        </>

    );
}


const field = (label: string, value: string) => {
    return (
        <div className="cabecalho-detalhe-item">
            <Typography className="cabecalho-detalhe-label">{label}</Typography>
            <Typography className="cabecalho-detalhe-value">{value !== undefined ? value : ""}</Typography>
        </div>
    )
}